module.exports = __webpack_public_path__ + "img/essenger.sh.3758987b.svg";